import { render, staticRenderFns } from "./FAQMan.vue?vue&type=template&id=566c9056&scoped=true&"
var script = {}
import style0 from "./FAQMan.vue?vue&type=style&index=0&id=566c9056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c9056",
  null
  
)

export default component.exports